// extracted by mini-css-extract-plugin
export default {"root":"Slider_root__Uvab2","slide":"Slider_slide__dJmK2"};